<script setup lang="ts">
  import type { ISection, ITabs } from '@/components/main-header/types'
  import { useMainHeaderStore } from '@/components/main-header/store'

  defineProps<{
    headerData: {
      tabs: ITabs[]
      sections: ISection[]
    }
  }>()

  const localePath = useLocalePath()

  const mainHeaderStore = useMainHeaderStore()

  const { currentRoute } = useRouter()
  const openTabQueryVal = currentRoute.value.query.opentab

  if (openTabQueryVal) {
    mainHeaderStore.activeTab = Array.isArray(openTabQueryVal) ? String(openTabQueryVal[0]) : openTabQueryVal
  }

  function toggleActiveSection(section: ISection) {
    if (mainHeaderStore.activeSection?.label === section?.label) {
      mainHeaderStore.activeSection = null

      return
    }

    mainHeaderStore.activeSection = section
  }
</script>
<template>
  <div class="container p-0 md:flex md:justify-between">
    <div data-test="tabs">
      <NuxtLink
        v-for="item in headerData.tabs"
        :key="item.key"
        :to="localePath({ path: '/', query: { opentab: item.key } })"
        class="inline-block border-b-4 border-transparent px-4 py-3 no-underline"
        :class="{
          '!border-bt-green font-medium': mainHeaderStore.activeTab === item.key && !mainHeaderStore.isMenuOpen
        }"
        external
        no-prefetch
        @click="mainHeaderStore.activeTab = item.key"
      >
        {{ item.label }}
      </NuxtLink>
    </div>
    <div
      data-test="sections"
      class="hidden md:flex"
    >
      <button
        v-for="item in headerData.sections"
        :key="item.label"
        class="inline-block border-b-4 border-transparent px-4 py-3 font-medium"
        :class="{
          '!border-bt-green font-medium':
            item.label === mainHeaderStore.activeSection?.label && mainHeaderStore.isMenuOpen
        }"
        @click="toggleActiveSection(item)"
      >
        {{ item.label }}
      </button>
    </div>
  </div>
</template>
